import { render, staticRenderFns } from "./judge_card.vue?vue&type=template&id=9e935e98&scoped=true"
import script from "./judge_card.vue?vue&type=script&lang=js"
export * from "./judge_card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e935e98",
  null
  
)

export default component.exports